import React from "react";

const PulsatingLoder = () => {
  return (
    <div className="fixed top-0 left-0 right-0 h-2 bg-gradient-to-r from-blue-500 to-purple-500 animate-pulse"></div>
  );
};

export default PulsatingLoder;
